import { QueryClient } from "react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime:            5 * 60 * 1000,  // 5 min default for all queries
      cacheTime:            10 * 60 * 1000, // 10 min default for all queries
      refetchOnWindowFocus: false,           // prevent refetch on tab switch
      retry:                2,
    },
  },
});
